import { useMemo } from 'react';
import {
  EventAccordionItemBodyComponentType,
  MinRowsForUsingVirtuoso,
} from 'src/components/Accordions';
import { useAppContext } from 'src/contexts/AppContext';
import { useCollapsableViewContext } from 'src/contexts/CollapsableViewContext/CollapsableViewContext';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { MainRoute } from 'src/navigations/Routes/MainRoute';
import { ListingTable } from 'src/tables/ListingTable';
import { ListingTableV2 } from 'src/tables/ListingTable/ListingTableV2';
import { ListingTiles } from 'src/tiles/ListingTiles';
import { ListingTilesV2 } from 'src/tiles/ListingTilesV2/ListingTilesV2';
import { Feature, Listing } from 'src/WebApiController';

type InventoryEventsBodyProps = EventAccordionItemBodyComponentType<Listing>;

export const InventoryEventsBody = (props: InventoryEventsBodyProps) => {
  const isMobile = useMatchMedia('mobile');
  const { mainRoute } = useAppContext();

  const hasMobileInventoryEventPageFeature = useUserHasFeature(
    Feature.MobileInventoryEventPage
  );
  const hasListingTableV2Feature = useUserHasFeature(Feature.ListingTableV2);

  const Body = isMobile
    ? hasMobileInventoryEventPageFeature
      ? ListingTilesV2
      : ListingTiles
    : hasListingTableV2Feature && !props.isSideTable
      ? ListingTableV2
      : ListingTable;

  const hasVirtuosoMinRows = props.entityCount > MinRowsForUsingVirtuoso;
  const hasEventHeaderReworkFeature = useUserHasFeature(
    Feature.EventHeaderRework
  );
  const { isEnabled } = useCollapsableViewContext();
  const shouldUseTableOuterPadding = useMemo(() => {
    if (hasEventHeaderReworkFeature && mainRoute === MainRoute.InventoryEvent) {
      return false;
    }
    return !isEnabled;
  }, [hasEventHeaderReworkFeature, isEnabled, mainRoute]);

  return (
    <Body
      {...props}
      useVirtuoso={isEnabled || hasVirtuosoMinRows}
      tableWithOuterPadding={shouldUseTableOuterPadding}
      enableColumnFilters
    />
  );
};
